export enum CapacityStatus {
  UnderPaidLimit,
  CloseToPaidLimit,
  AtPaidLimit,
  OverPaidLimit,
  AtEnforcedLimit,
}

export type TCapacityStatus = keyof typeof CapacityStatus;
